
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import empService from '../../services/empService';

export const fetchAllEMP = createAsyncThunk('emp/fetchAll', async (_, { getState }) => {
  return await empService.getAllEmployees(getState().auth.token);
});

export const addEMPEmployee = createAsyncThunk('emp/add', async (formData, { getState }) => {
  const body = {
    p_ced_service_no: formData.p_ced_service_no || '', p_title: formData.p_title || '',
    p_sex: formData.p_sex || '', p_initials: formData.p_initials || '',
    p_first_name: formData.p_first_name || '', p_last_name: formData.p_last_name || '',
    p_report_name: formData.p_report_name || '', p_cat_code: formData.p_cat_code || '',
    p_newold: formData.p_newold || 'N', p_barcode: formData.p_barcode || '',
    p_contact_address_1: formData.p_contact_address_1 || '', p_contact_address_2: formData.p_contact_address_2 || '',
    p_contact_town: formData.p_contact_town || '', p_contact_city: formData.p_contact_city || '',
    p_contact_tel: formData.p_contact_tel || '', p_off_mobile: formData.p_off_mobile || '',
    p_mobile: formData.p_mobile || '', p_contact_distance: formData.p_contact_distance || '',
    p_home_address_1: formData.p_home_address_1 || '', p_home_address_2: formData.p_home_address_2 || '',
    p_home_town: formData.p_home_town || '', p_home_city: formData.p_home_city || '',
    p_home_distance: formData.p_home_distance || '', p_home_tel: formData.p_home_tel || '',
    p_electorate: formData.p_electorate || '', p_police_station: formData.p_police_station || '',
    p_location_code: formData.p_location_code || '', p_department_code: formData.p_department_code || '',
    p_division_code: formData.p_division_code || '', p_extension: formData.p_extension || '',
    p_email: formData.p_email || '', p_initial_category: formData.p_initial_category || '',
    p_initial_grade: formData.p_initial_grade || '', p_retirement_date: formData.p_retirement_date || '',
    p_recruitment_date: formData.p_recruitment_date || '',
    p_shift1: formData.p_shift1 || '0', p_shift2: formData.p_shift2 || '0', p_shift3: formData.p_shift3 || '0',
    p_inactive_type: formData.p_inactive_type || '', p_union_code: formData.p_union_code || '',
    p_association_code: formData.p_association_code || '', p_gramasewaka: formData.p_gramasewaka || '',
    p_marital_status: formData.p_marital_status || '', p_nid: formData.p_nid || '',
    p_passport: formData.p_passport || '', p_licence: formData.p_licence || '',
    p_birth_date: formData.p_birth_date || '', p_first_employer: formData.p_first_employer || '',
    p_employee_category: formData.p_employee_category || '', p_work_category: formData.p_work_category || '',
    p_epf: formData.p_epf || '', p_breakfast: formData.p_breakfast || 'N',
    p_meal: formData.p_meal || 'N', p_snack: formData.p_snack || 'N',
    p_nok_fname: formData.p_nok_fname || '', p_nok_lname: formData.p_nok_lname || '',
    p_nok_address: formData.p_nok_address || '', p_nok_tel: formData.p_nok_tel || '',
    p_nok_relation: formData.p_nok_relation || '', p_spouse_fname: formData.p_spouse_fname || '',
    p_spouse_lname: formData.p_spouse_lname || '', p_spouse_dob: formData.p_spouse_dob || '',
    p_children: formData.p_children || '', p_own_home: formData.p_own_home || '',
    p_rent: formData.p_rent || '', p_vehicle: formData.p_vehicle || '',
    p_vehicle_type: formData.p_vehicle_type || '', p_vehicle_no: formData.p_vehicle_no || '',
    p_transport: formData.p_transport || '', p_religion: formData.p_religion || '',
    p_race: formData.p_race || '', p_info: formData.p_info || '',
    p_fe_start: formData.p_fe_start || '', p_fe_end: formData.p_fe_end || '',
    p_ehrs: formData.p_ehrs || 'N', p_prof_qual: formData.p_prof_qual || '',
    p_skills: formData.p_skills || '', p_odate: formData.p_odate || '',
    p_leave_remarks: formData.p_leave_remarks || '0', p_reporting_officer: formData.p_reporting_officer || '',
    p_qualification: formData.p_qualification || '', p_present_grade: formData.p_present_grade || '',
    p_attenpay: formData.p_attenpay || 'N', p_snack_location: formData.p_snack_location || '',
    p_proximity: formData.p_proximity || '', p_contract: formData.p_contract || '',
    p_jcat: formData.p_jcat || '', p_jmain: formData.p_jmain || '',
    p_created_by: formData.p_created_by || 'HR_ADMIN', p_updated_by: formData.p_updated_by || 'HR_ADMIN',
    p_blood_group: formData.p_blood_group || '', p_cdl_service_no: formData.p_cdl_service_no || '',
    p_ip: formData.p_ip || '192.168.1.1', p_device: formData.p_device || 'Web',
  };
  return await empService.addEmployee(body, getState().auth.token);
});

const empSlice = createSlice({
  name: 'emp',
  initialState: {
    employees: [], loading: false, adding: false,
    error: null, successMessage: null,
  },
  reducers: {
    clearEMPError: (state) => { state.error = null; },
    clearEMPSuccess: (state) => { state.successMessage = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllEMP.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAllEMP.fulfilled, (state, action) => { state.loading = false; state.employees = action.payload; })
      .addCase(fetchAllEMP.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(addEMPEmployee.pending, (state) => { state.adding = true; state.error = null; state.successMessage = null; })
      .addCase(addEMPEmployee.fulfilled, (state, action) => {
        state.adding = false;
        state.successMessage = 'Employee added successfully!';
        if (action.payload) state.employees.unshift(action.payload);
      })
      .addCase(addEMPEmployee.rejected, (state, action) => { state.adding = false; state.error = action.error.message; });
  },
});

export const { clearEMPError, clearEMPSuccess } = empSlice.actions;
export default empSlice.reducer;
